export const frontmatter = {
    "draft": true,
    "title": "Tokens de acceso",
    "description": "Gestión de tokens de acceso en OnnIA.",
    "sidebar_label": "Tokens de acceso",
    "sidebar_group": "referencia",
    "sidebar_order": 5
}

export const toc = []